<template>
  <div class="employee-list-cla">
    <div class="flex-item-cla1">
      <orgTree
        :isSelectDefault="true"
        ref="orgTree"
        @selectNode="selectNode"
        @getOrgTree="getOrgTree"
      ></orgTree>
    </div>
    <div class="flex-item-cla2">
      <employeeList
        @selectCurrentRow="selectCurrentRow"
        :currentOrg="currentOrg"
        :orgTree="orgTree"
      ></employeeList>
    </div>
    <div class="flex-item-cla3">
      <employeeInfo :currentEmp="currentEmp"></employeeInfo>
    </div>
  </div>
</template>

<script>
import orgTree from './orgStructure/orgTree'
import employeeList from './employee/employeeList'
import employeeInfo from './employee/employeeInfo'
export default {
  data() {
    return {
      currentOrg: {},
      currentEmp: {},
      orgTree: []
    }
  },

  mounted() {},
  methods: {
    selectNode(node) {
      if (node) {
        this.currentOrg = node.data
      } else {
        this.currentOrg = {}
      }
    },
    selectCurrentRow(row) {
      this.currentEmp = row
      if (this.currentEmp) {
        this.currentEmp.dept = this.currentOrg.organizationName
      }
    },
    getOrgTree(data) {
      this.orgTree = data
    }
  },
  components: {
    orgTree,
    employeeList,
    employeeInfo
  }
}
</script>

<style scoped lang="less">
.employee-list-cla {
  display: flex;
  .flex-item-cla {
    background-color: #ffffff;
    padding: 20px;
  }

  .flex-item-cla1 {
    .flex-item-cla;
    padding-left: 0px;
    width: 25%;
  }
  .flex-item-cla2 {
    .flex-item-cla;
    margin-left: 15px;
    width: 35%;
  }
  .flex-item-cla3 {
    .flex-item-cla;
    margin-left: 15px;
    width: 40%;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/employee.vue